import React from 'react';
import {Box, IconButton, Typography} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

/**
 * Collapsible header for the summary section.
 */
const SummaryHeader = ({expanded, onToggle}) => (
    <Box
        onClick={onToggle}
        sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 2,
            py: 0.5,
            minHeight: 36,
            cursor: 'pointer',
            bgcolor: 'white',
            '&:hover': {bgcolor: 'action.hover'},
        }}
    >
        <Typography variant="body2" fontWeight={600} color="text.secondary">
            Summary
        </Typography>
        <IconButton
            size="small"
            sx={{
                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s',
            }}
        >
            <ExpandMoreIcon fontSize="small"/>
        </IconButton>
    </Box>
);

export default SummaryHeader;
